(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-flexible"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const main = root.querySelector('.mf-main-image');
    const thumbs = [...root.querySelectorAll('.mf-thumb')];
    const image = (url, alt) => {
      if (!url || !main) return;
      main.removeAttribute('srcset');
      main.src = url;
      if (alt) main.alt = alt;
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.image === url;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => image(thumb.dataset.image, thumb.dataset.alt)));
    root.querySelectorAll('[data-quantity-control]').forEach((control) => {
      const input = control.querySelector('[name="quantity"]');
      const minus = control.querySelector('[data-quantity-minus]');
      const plus = control.querySelector('[data-quantity-plus]');
      const normalize = () => {
        const minimum = Number(input.min) || 1;
        const maximum = input.max ? Number(input.max) : Infinity;
        const quantity = Number.isFinite(input.valueAsNumber) ? Math.trunc(input.valueAsNumber) : minimum;
        input.value = String(Math.min(maximum, Math.max(minimum, quantity)));
        minus.disabled = Number(input.value) <= minimum;
        plus.disabled = Number(input.value) >= maximum;
      };
      const adjust = (amount) => {
        normalize();
        input.value = String(Number(input.value) + amount);
        normalize();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      minus.addEventListener('click', () => adjust(-1));
      plus.addEventListener('click', () => adjust(1));
      input.addEventListener('input', () => {
        minus.disabled = !Number.isFinite(input.valueAsNumber) || input.valueAsNumber <= (Number(input.min) || 1);
        plus.disabled = Boolean(input.max) && input.valueAsNumber >= Number(input.max);
      });
      input.addEventListener('change', normalize);
      normalize();
    });
    const picker = root.querySelector('[data-variants]');
    const form = root.querySelector('.mf-block--buy_buttons form');
    const variantRadios = [...root.querySelectorAll('[data-variant-radio]')];
    variantRadios.forEach((radio) => radio.addEventListener('change', () => {
      if (!radio.checked || !picker || radio.disabled) return;
      picker.value = radio.value;
      picker.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    picker?.addEventListener('change', () => {
      const selected = picker.selectedOptions[0];
      if (!selected) return;
      const available = selected.dataset.available === 'true';
      variantRadios.forEach((radio) => { radio.checked = radio.value === selected.value; });
      root.querySelectorAll('.mf-prices [data-price]').forEach((el) => { el.innerHTML = selected.dataset.price; });
      root.querySelectorAll('.mf-prices [data-compare]').forEach((el) => {
        el.innerHTML = selected.dataset.compare || '';
        el.hidden = !selected.dataset.compare || el.closest('.mf-prices').dataset.showCompare === 'false';
      });
      root.querySelectorAll('.mf-prices [data-saving]').forEach((el) => {
        const percent = Number(selected.dataset.saving || 0);
        el.querySelector('[data-saving-value]').textContent = String(percent);
        el.hidden = percent < 1 || el.closest('.mf-prices').dataset.showSaving === 'false';
      });
      if (form) {
        const id = form.querySelector('[data-variant-id]');
        id.value = selected.value;
        id.dispatchEvent(new Event('change', { bubbles: true }));
        const submit = form.querySelector('[data-submit]');
        submit.disabled = !available;
        form.querySelectorAll('[data-checkout]').forEach((button) => { button.disabled = !available; });
        submit.textContent = available ? root.dataset.add : root.dataset.sold;
        const express = form.querySelector('.shopify-payment-button');
        if (express) express.hidden = !available;
      }
      image(selected.dataset.image);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url);
    });
    if (form) {
      const available = !form.querySelector('[data-submit]').disabled;
      const express = form.querySelector('.shopify-payment-button');
      if (express) express.hidden = !available;
    }
  };
  const scan = () => document.querySelectorAll('[data-flexible-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-seed-calendar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = document.getElementById(root.dataset.formId);
    if (!form) return;
    const main = root.querySelector('.mc-main-image');
    const thumbs = [...root.querySelectorAll('.mc-thumb')];
    const showImage = (url, alt) => {
      if (!main || !url) return;
      main.removeAttribute('srcset');
      main.src = url;
      if (alt) main.alt = alt;
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.image === url;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(thumb.dataset.image, thumb.dataset.alt)));
    const radios = [...form.querySelectorAll('input[name="id"]')];
    const update = () => {
      const selected = radios.find((radio) => radio.checked);
      const available = selected && !selected.disabled;
      root.querySelectorAll('[data-submit], [data-sticky-submit]').forEach((submit) => {
        submit.disabled = !available;
        submit.textContent = available ? root.dataset.add : root.dataset.sold;
      });
      const express = form.querySelector('.shopify-payment-button');
      if (express) express.hidden = !available;
      if (!selected) return;
      root.querySelectorAll('[data-price]:not(input)').forEach((el) => { el.innerHTML = selected.dataset.price; });
      root.querySelectorAll('[data-compare]:not(input)').forEach((compare) => {
        compare.innerHTML = selected.dataset.compare;
        compare.hidden = !selected.dataset.compare;
      });
      root.querySelectorAll('[data-saving]:not(input)').forEach((saving) => {
        saving.textContent = selected.dataset.saving || '';
        saving.hidden = !selected.dataset.saving;
      });
      const stickyPicker = root.querySelector('[data-sticky-variant]');
      if (stickyPicker) stickyPicker.value = selected.value;
      showImage(selected.dataset.image);
    };
    radios.forEach((radio) => radio.addEventListener('change', () => {
      update();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    }));
    const stickyPicker = root.querySelector('[data-sticky-variant]');
    stickyPicker?.addEventListener('change', () => {
      const selected = radios.find((radio) => radio.value === stickyPicker.value && !radio.disabled);
      if (!selected) return;
      selected.checked = true;
      selected.dispatchEvent(new Event('change', { bubbles: true }));
    });
    form.querySelectorAll('[data-qty]').forEach((button) => button.addEventListener('click', () => {
      const quantity = form.querySelector('[name="quantity"]');
      quantity.value = Math.max(1, (Number.parseInt(quantity.value, 10) || 1) + Number(button.dataset.qty));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    update();
    const sticky = root.querySelector('.mc-sticky');
    const buy = root.querySelector('.mc-buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      const footer = document.querySelector('.mavoniqo-footer') || document.querySelector('footer');
      const refresh = () => {
        const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const nearBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 8;
        sticky.hidden = footerVisible || nearBottom || buy.getBoundingClientRect().top > window.innerHeight * 0.6;
      };
      const observer = new IntersectionObserver(refresh);
      observer.observe(buy);
      window.addEventListener('scroll', refresh, { passive: true, signal: (root._mcController = new AbortController()).signal });
      root._mcObserver = observer;
    }
  };
  const scan = () => document.querySelectorAll('[data-calendar]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-calendar]').forEach((root) => {
      root._mcObserver?.disconnect();
      root._mcController?.abort();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
